import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import config from "../../config";
import LeftSidebar from "../Common/LeftSidebar";
import Loader from "../Common/Loader";
import RightIconMenu from "../Common/RightIconMenu";
import RightSidebar from "../Common/RightSidebar";

import { username, role } from "../Actions/AuthAction";
import { token } from "../Actions/AuthAction";
import { getJobsList } from "../Actions/JobAction";
import { listDrive } from "../Actions/DriveAction";
import { actionAppliedCandidateList } from "../Actions/CandidateAction";

const EmployerDashboard = (props) => {
  const [totalJobs, setTotalJobs] = useState(0);
  const [totalDrive, setTotalDrive] = useState(0);
  const [totalappliedCandidates, setTotalAppliedCandidates] = useState(0);
  const [totalselectedCandidates, setTotalSelectedCandidates] = useState(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getJobsList({
      page: "1",
      token: token(),
      recruiterid: "",
      employeeid: "",
      sector: "",
    }).then((res) => {
      //alert();
      if (res.status) {
        setTotalJobs(res.totaldata);
      }
    });

    listDrive({
      loginusertoken: token(),
      page: "1",
      startdate: "",
      enddate: "",
      instid: "",
      venuestatus: "",
      drivetype: "",
      drivestatus: "",
    }).then((res) => {
      if (res.status) {
        setTotalDrive(res.totaldata);
      }
    });

    actionAppliedCandidateList({
      loginusertoken: token(),
      page: 1,
      search: "",
      status: 1,
      search: "",
      limit: "",
      instid: "",
    }).then((res) => {
      if (res.status) {
        setTotalAppliedCandidates(res.totaldata);
      } else {
        setTotalAppliedCandidates(0);
      }
    });

    actionAppliedCandidateList({
      loginusertoken: token(),
      page: 1,
      search: "",
      status: 2,
      search: "",
      limit: "",
      instid: "",
    }).then((res) => {
      if (res.status) {
        setTotalSelectedCandidates(res.totaldata);

        setLoading(false);
      } else {
        setTotalSelectedCandidates(0);

        setLoading(false);
      }
    });
  }, []);

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div class="row mt-5">
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/listjob" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Jobs
                  <span class="d-block text-danger mt-4">{totalJobs}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {""}
                  <i class="d-block text-danger dashboardiconimg fas fa-graduation-cap"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/drivelist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Drives
                  <span class="d-block text-danger mt-4">{totalDrive}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {""}
                  <i class="d-block text-danger dashboardiconimg fas fa-building"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/appliedcandidatelist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Applied Candidates
                  <span class="d-block text-danger mt-4">
                    {totalappliedCandidates}
                  </span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {""}
                  <i class="d-block text-danger dashboardiconimg fas fa-users"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/allselectcandidatelist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Selected Candidates
                  <span class="d-block text-danger mt-4">
                    {totalselectedCandidates}
                  </span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-users"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default EmployerDashboard;
